@import "../../../styles/base";

#modal-container {
  position: fixed;
}

.container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  color: $ds-violet-900;

  &::backdrop {
    // We handle this ourselves, partly for the click events and partly for legacy reasons
    display: none;
  }
}

.cover {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  transition: opacity 150ms;
  background-color: $ds-violet-900;
  opacity: 0;

  &.dimBackground {
    opacity: 0.3;
  }
}
